import script from "./JobDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./JobDetails.vue?vue&type=script&setup=true&lang=js"

import "./JobDetails.vue?vue&type=style&index=0&id=639cd57d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/employer/employer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-639cd57d"]])

export default __exports__